// eslint-disable-next-line
/* eslint-disable */

import { api } from './config'
import request from './request'


export default {
    apoio: {
        retornarPacientesNaoConsultados() { //ok
            //return api.get(`/apoio/retornarPacientesNaoConsultados/${idUnidade}/${idLocal}`)
            return request({
                url: `/apoio/retornarPacientesNaoConsultados/`,
                method: 'get'
            })
        },

        retornarPacienteAFila(idAtendimento, idLocalMedico, codigo,
            nomeEspecialidade, nomePaciente, idServico, idExame, idMedico, nomeExame, dataStatus) { //ok
            var obj = {
                    idAtendimento: idAtendimento,
                    idLocalMedico: idLocalMedico,
                    codigo: codigo,
                    nomeEspecialidade: nomeEspecialidade,
                    nomePaciente: nomePaciente,
                    idServico: idServico,
                    idExame: idExame,
                    idMedico: idMedico,
                    nomeExame: nomeExame,
                    dataStatus: dataStatus
                }
                //return api.post('/apoio/retornarPacienteAFila',obj)  
            return request({
                url: '/apoio/retornarPacienteAFila/',
                method: 'post',
                data: obj
            })
        },

    }
}